import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
import { Staffs } from '@/modules/staffs/types';
import { Organizations } from '@/modules/organizations/types';
import { default_manager_new_details, default_company_user_staff_filters } from '../../../services';
import { CompaniesUsers } from '../../../types';

export default class CompanyUserStaffState extends BaseState {
  company_user_staff: Staffs.Staff[] = [];
  company_user_staff_loading = false;
  current_user_company: Organizations.Organization | null = null;
  filters: CompaniesUsers.CompanysUserStaffFilters = default_company_user_staff_filters();

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['full_name'],
    sortDesc: [true],
  };

  manager_new_details: Staffs.Staff = {} as Staffs.Staff;

  current_staff: Staffs.Staff = {} as Staffs.Staff;
  editable_staff: Staffs.Staff = {} as Staffs.Staff;
}
